module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img.f99cbbc1.webp";